export default (string) => `activities-search-form__${string}`;
